import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchInitiativeAction, saveInitiativeCommentAction, 
  fetchInitiativeJournalsAction, saveInitiativeDecisionAction,
  sendInitiativeOpinionRequestsAction, reAssignInitiativeAction,
  fetchCostCentersAction, saveRewardAction, fetchInitiativeTypesAction, putInitiativeAction
} from '../actions/';
import Main from '../components/App';
import ProcessInitiativePage from '../components/ProcessIdeas/ProcessInitiativePage';

class ProcessInitiativeContainer extends Component {
  render() {
    const { actions } = this.props;
    const { currentInitiative } = this.props;
    const { ideaId } = this.props.params;
    const {costCenters} = this.props;
    const {authInfo} = this.props;
    const {initiativeTypes} = this.props;
    const {locale} = this.props;

    return <ProcessInitiativePage locale={locale} authInfo={authInfo} actions={actions} currentInitiative={currentInitiative} ideaId={ideaId} costCenters={costCenters} initiativeTypes={initiativeTypes}/>;
  }
  
  componentDidMount() {
    const {actions} = this.props;
    const { ideaId } = this.props.params;
    actions.fetchInitiativeAction(ideaId).then(() => {
      actions.fetchInitiativeJournalsAction(ideaId);
    });
    actions.fetchCostCentersAction();
    actions.fetchInitiativeTypesAction();
    
  }
}

ProcessInitiativeContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    currentInitiative : state.currentInitiative, 
    costCenters : state.costCenters,
    authInfo : state.authInfo,
    initiativeTypes : state.initiativeTypes,
    locale : state.locale
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchInitiativeAction, saveInitiativeCommentAction, 
                  fetchInitiativeJournalsAction, saveInitiativeDecisionAction,
                   sendInitiativeOpinionRequestsAction,
                  reAssignInitiativeAction,fetchCostCentersAction, saveRewardAction, fetchInitiativeTypesAction, putInitiativeAction};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessInitiativeContainer);



// WEBPACK FOOTER //
// ./containers/ProcessInitiativeContainer.js